import { HTMLAttributes, CSSProperties } from 'react';
import noop from '../../utils/noop';
import withTouchable from './withTouchable';

interface Props extends HTMLAttributes<HTMLDivElement> {
  scaleSize?: number;
}
const TouchableScale = withTouchable<Props>(props => {
  return {
    transform: `scale(${props.scaleSize})`,
  } as CSSProperties;
}, 'touchable-scale');

const styleEl = document.createElement('style');

styleEl.innerHTML = `.touchable-scale{
transition: transform .2s ease;
}`;

document.head.appendChild(styleEl);

TouchableScale.defaultProps = {
  onTouch: noop,
  onClick: noop,
  disabled: false,
  scaleSize: 0.8,
};

export default TouchableScale;
